import type { ReactNode } from "react";
import clsx from "clsx";
import type { SortState } from "@/components/dataTable/tableSort";

export function SortableHeader({
  label,
  columnKey,
  sort,
  onSort,
}: {
  label: ReactNode;
  columnKey: string;
  sort: SortState | null;
  onSort: (key: string) => void;
}) {
  const active = sort?.key === columnKey;
  const indicator = !active ? "\u2195" : sort.direction === "asc" ? "\u2191" : "\u2193";

  return (
    <button
      type="button"
      className={clsx(
        "inline-flex max-w-full items-center gap-1 text-left transition hover:text-label",
        active ? "text-label" : "text-label-secondary",
      )}
      aria-sort={
        active ? (sort.direction === "asc" ? "ascending" : "descending") : "none"
      }
      onClick={() => onSort(columnKey)}
    >
      <span className="min-w-0">{label}</span>
      <span className="shrink-0 text-[10px] leading-none opacity-70" aria-hidden>
        {indicator}
      </span>
    </button>
  );
}
